import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useWorkspace } from '../../context/WorkspaceContext';

/**
 * Route guard for mutation-only pages (add/edit/capture). Viewers of a shared
 * move are bounced back to the dashboard — the UI complement to the Firestore
 * rules, which remain the hard server-side guard.
 */
export function RequireEdit({ children }: { children: ReactNode }) {
  const { canEdit } = useWorkspace();
  if (!canEdit) return <Navigate to="/app" replace />;
  return <>{children}</>;
}
